import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Stack, Inline } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';
import { Briefcase, MapPin, Eye, Users, Star } from 'lucide-react';

const RecentJobs = ({ jobs }) => {
  const navigate = useNavigate();

  const handleApplicantClick = (jobId) => {
    navigate(`/ranking?jobID=${encodeURIComponent(jobId)}`);
  };

  return (
    <Card className="border border-border shadow-md">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle>Recent Job</CardTitle>
          <Button variant="outline" size="sm" onClick={() => navigate("/ch")}>
            View All Jobs
          </Button>
        </div>
      </CardHeader>
      <Separator />
      <CardContent>
        <Stack spacing="md">
          <Heading level="h3" className="text-lg font-semibold">
            Jobs Published ({jobs.length})
          </Heading>
          <Stack spacing="sm">
            {jobs.slice(0, 4).map((job) => (
              <Card
                key={job.job_id}
                className="cursor-pointer hover:bg-muted/50 transition-colors"
                onClick={() => handleApplicantClick(job.job_id)}
              >
                <CardContent className="p-4">
                  <Stack spacing="sm">
                    <div>
                      <Heading level="h4" className="text-base font-semibold mb-1">
                        {job.job_title}
                      </Heading>
                      <Text variant="muted" className="text-sm flex items-center gap-1">
                        <MapPin className="w-3 h-3" />
                        {job.experience_range} - {job.location}
                      </Text>
                    </div>
                    <Inline spacing="md" className="text-sm text-muted-foreground">
                      <span className="flex items-center gap-1">
                        <Eye className="w-4 h-4" />
                        {job.applicants} Views
                      </span>
                      <span className="flex items-center gap-1">
                        <Users className="w-4 h-4" />
                        {job.applicants} Applied
                      </span>
                      <span className="flex items-center gap-1">
                        <Star className="w-4 h-4" />
                        {job.applicants} Recommended Candidates
                      </span>
                    </Inline>
                  </Stack>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default RecentJobs;
